/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiEquipmentSettingCreateEquipmentSettingPost } from '../fn/settings-project-resources/api-equipment-setting-create-equipment-setting-post';
import { ApiEquipmentSettingCreateEquipmentSettingPost$Params } from '../fn/settings-project-resources/api-equipment-setting-create-equipment-setting-post';
import { apiEquipmentSettingCreateEquipmentSettingPost$Plain } from '../fn/settings-project-resources/api-equipment-setting-create-equipment-setting-post-plain';
import { ApiEquipmentSettingCreateEquipmentSettingPost$Plain$Params } from '../fn/settings-project-resources/api-equipment-setting-create-equipment-setting-post-plain';
import { apiEquipmentSettingDeleteEquipmentSettingDelete } from '../fn/settings-project-resources/api-equipment-setting-delete-equipment-setting-delete';
import { ApiEquipmentSettingDeleteEquipmentSettingDelete$Params } from '../fn/settings-project-resources/api-equipment-setting-delete-equipment-setting-delete';
import { apiEquipmentSettingDeleteEquipmentSettingDelete$Plain } from '../fn/settings-project-resources/api-equipment-setting-delete-equipment-setting-delete-plain';
import { ApiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Params } from '../fn/settings-project-resources/api-equipment-setting-delete-equipment-setting-delete-plain';
import { apiEquipmentSettingGetEquipmentSettingsPost } from '../fn/settings-project-resources/api-equipment-setting-get-equipment-settings-post';
import { ApiEquipmentSettingGetEquipmentSettingsPost$Params } from '../fn/settings-project-resources/api-equipment-setting-get-equipment-settings-post';
import { apiEquipmentSettingGetEquipmentSettingsPost$Plain } from '../fn/settings-project-resources/api-equipment-setting-get-equipment-settings-post-plain';
import { ApiEquipmentSettingGetEquipmentSettingsPost$Plain$Params } from '../fn/settings-project-resources/api-equipment-setting-get-equipment-settings-post-plain';
import { apiEquipmentSettingUpdateEquipmentSettingPut } from '../fn/settings-project-resources/api-equipment-setting-update-equipment-setting-put';
import { ApiEquipmentSettingUpdateEquipmentSettingPut$Params } from '../fn/settings-project-resources/api-equipment-setting-update-equipment-setting-put';
import { apiEquipmentSettingUpdateEquipmentSettingPut$Plain } from '../fn/settings-project-resources/api-equipment-setting-update-equipment-setting-put-plain';
import { ApiEquipmentSettingUpdateEquipmentSettingPut$Plain$Params } from '../fn/settings-project-resources/api-equipment-setting-update-equipment-setting-put-plain';
import { apiManpowerSettingCreateManpowerSettingPost } from '../fn/settings-project-resources/api-manpower-setting-create-manpower-setting-post';
import { ApiManpowerSettingCreateManpowerSettingPost$Params } from '../fn/settings-project-resources/api-manpower-setting-create-manpower-setting-post';
import { apiManpowerSettingCreateManpowerSettingPost$Plain } from '../fn/settings-project-resources/api-manpower-setting-create-manpower-setting-post-plain';
import { ApiManpowerSettingCreateManpowerSettingPost$Plain$Params } from '../fn/settings-project-resources/api-manpower-setting-create-manpower-setting-post-plain';
import { apiManpowerSettingDeleteManpowerSettingDelete } from '../fn/settings-project-resources/api-manpower-setting-delete-manpower-setting-delete';
import { ApiManpowerSettingDeleteManpowerSettingDelete$Params } from '../fn/settings-project-resources/api-manpower-setting-delete-manpower-setting-delete';
import { apiManpowerSettingDeleteManpowerSettingDelete$Plain } from '../fn/settings-project-resources/api-manpower-setting-delete-manpower-setting-delete-plain';
import { ApiManpowerSettingDeleteManpowerSettingDelete$Plain$Params } from '../fn/settings-project-resources/api-manpower-setting-delete-manpower-setting-delete-plain';
import { apiManpowerSettingGetManpowerSettingsPost } from '../fn/settings-project-resources/api-manpower-setting-get-manpower-settings-post';
import { ApiManpowerSettingGetManpowerSettingsPost$Params } from '../fn/settings-project-resources/api-manpower-setting-get-manpower-settings-post';
import { apiManpowerSettingGetManpowerSettingsPost$Plain } from '../fn/settings-project-resources/api-manpower-setting-get-manpower-settings-post-plain';
import { ApiManpowerSettingGetManpowerSettingsPost$Plain$Params } from '../fn/settings-project-resources/api-manpower-setting-get-manpower-settings-post-plain';
import { apiManpowerSettingUpdateManpowerSettingPut } from '../fn/settings-project-resources/api-manpower-setting-update-manpower-setting-put';
import { ApiManpowerSettingUpdateManpowerSettingPut$Params } from '../fn/settings-project-resources/api-manpower-setting-update-manpower-setting-put';
import { apiManpowerSettingUpdateManpowerSettingPut$Plain } from '../fn/settings-project-resources/api-manpower-setting-update-manpower-setting-put-plain';
import { ApiManpowerSettingUpdateManpowerSettingPut$Plain$Params } from '../fn/settings-project-resources/api-manpower-setting-update-manpower-setting-put-plain';
import { CreateEquipmentSettingCommandResult } from '../models/create-equipment-setting-command-result';
import { CreateManpowerSettingCommandResult } from '../models/create-manpower-setting-command-result';
import { DeleteEquipmentSettingCommandResult } from '../models/delete-equipment-setting-command-result';
import { DeleteManpowerSettingCommandResult } from '../models/delete-manpower-setting-command-result';
import { GetEquipmentSettingQueryResult } from '../models/get-equipment-setting-query-result';
import { GetManpowerSettingQueryResult } from '../models/get-manpower-setting-query-result';
import { UpdateEquipmentSettingCommandResult } from '../models/update-equipment-setting-command-result';
import { UpdateManpowerSettingCommandResult } from '../models/update-manpower-setting-command-result';

@Injectable({ providedIn: 'root' })
export class SettingsProjectResourcesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiEquipmentSettingGetEquipmentSettingsPost()` */
  static readonly ApiEquipmentSettingGetEquipmentSettingsPostPath = '/api/EquipmentSetting/GetEquipmentSettings';

  /**
   * Gets a list of equipment settings based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingGetEquipmentSettingsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingGetEquipmentSettingsPost$Plain$Response(params?: ApiEquipmentSettingGetEquipmentSettingsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetEquipmentSettingQueryResult>> {
    return apiEquipmentSettingGetEquipmentSettingsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of equipment settings based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingGetEquipmentSettingsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingGetEquipmentSettingsPost$Plain(params?: ApiEquipmentSettingGetEquipmentSettingsPost$Plain$Params, context?: HttpContext): Observable<GetEquipmentSettingQueryResult> {
    return this.apiEquipmentSettingGetEquipmentSettingsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetEquipmentSettingQueryResult>): GetEquipmentSettingQueryResult => r.body)
    );
  }

  /**
   * Gets a list of equipment settings based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingGetEquipmentSettingsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingGetEquipmentSettingsPost$Response(params?: ApiEquipmentSettingGetEquipmentSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetEquipmentSettingQueryResult>> {
    return apiEquipmentSettingGetEquipmentSettingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of equipment settings based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingGetEquipmentSettingsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingGetEquipmentSettingsPost(params?: ApiEquipmentSettingGetEquipmentSettingsPost$Params, context?: HttpContext): Observable<GetEquipmentSettingQueryResult> {
    return this.apiEquipmentSettingGetEquipmentSettingsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetEquipmentSettingQueryResult>): GetEquipmentSettingQueryResult => r.body)
    );
  }

  /** Path part for operation `apiEquipmentSettingCreateEquipmentSettingPost()` */
  static readonly ApiEquipmentSettingCreateEquipmentSettingPostPath = '/api/EquipmentSetting/CreateEquipmentSetting';

  /**
   * Creates a new equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingCreateEquipmentSettingPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingCreateEquipmentSettingPost$Plain$Response(params?: ApiEquipmentSettingCreateEquipmentSettingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateEquipmentSettingCommandResult>> {
    return apiEquipmentSettingCreateEquipmentSettingPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingCreateEquipmentSettingPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingCreateEquipmentSettingPost$Plain(params?: ApiEquipmentSettingCreateEquipmentSettingPost$Plain$Params, context?: HttpContext): Observable<CreateEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingCreateEquipmentSettingPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateEquipmentSettingCommandResult>): CreateEquipmentSettingCommandResult => r.body)
    );
  }

  /**
   * Creates a new equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingCreateEquipmentSettingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingCreateEquipmentSettingPost$Response(params?: ApiEquipmentSettingCreateEquipmentSettingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateEquipmentSettingCommandResult>> {
    return apiEquipmentSettingCreateEquipmentSettingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingCreateEquipmentSettingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingCreateEquipmentSettingPost(params?: ApiEquipmentSettingCreateEquipmentSettingPost$Params, context?: HttpContext): Observable<CreateEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingCreateEquipmentSettingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateEquipmentSettingCommandResult>): CreateEquipmentSettingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiEquipmentSettingUpdateEquipmentSettingPut()` */
  static readonly ApiEquipmentSettingUpdateEquipmentSettingPutPath = '/api/EquipmentSetting/UpdateEquipmentSetting';

  /**
   * Updates an existing equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingUpdateEquipmentSettingPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingUpdateEquipmentSettingPut$Plain$Response(params?: ApiEquipmentSettingUpdateEquipmentSettingPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateEquipmentSettingCommandResult>> {
    return apiEquipmentSettingUpdateEquipmentSettingPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingUpdateEquipmentSettingPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingUpdateEquipmentSettingPut$Plain(params?: ApiEquipmentSettingUpdateEquipmentSettingPut$Plain$Params, context?: HttpContext): Observable<UpdateEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingUpdateEquipmentSettingPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateEquipmentSettingCommandResult>): UpdateEquipmentSettingCommandResult => r.body)
    );
  }

  /**
   * Updates an existing equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingUpdateEquipmentSettingPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingUpdateEquipmentSettingPut$Response(params?: ApiEquipmentSettingUpdateEquipmentSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateEquipmentSettingCommandResult>> {
    return apiEquipmentSettingUpdateEquipmentSettingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingUpdateEquipmentSettingPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingUpdateEquipmentSettingPut(params?: ApiEquipmentSettingUpdateEquipmentSettingPut$Params, context?: HttpContext): Observable<UpdateEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingUpdateEquipmentSettingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateEquipmentSettingCommandResult>): UpdateEquipmentSettingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiEquipmentSettingDeleteEquipmentSettingDelete()` */
  static readonly ApiEquipmentSettingDeleteEquipmentSettingDeletePath = '/api/EquipmentSetting/DeleteEquipmentSetting';

  /**
   * Deletes an existing equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingDeleteEquipmentSettingDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Response(params?: ApiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteEquipmentSettingCommandResult>> {
    return apiEquipmentSettingDeleteEquipmentSettingDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingDeleteEquipmentSettingDelete$Plain(params?: ApiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Params, context?: HttpContext): Observable<DeleteEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingDeleteEquipmentSettingDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteEquipmentSettingCommandResult>): DeleteEquipmentSettingCommandResult => r.body)
    );
  }

  /**
   * Deletes an existing equipment setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEquipmentSettingDeleteEquipmentSettingDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingDeleteEquipmentSettingDelete$Response(params?: ApiEquipmentSettingDeleteEquipmentSettingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteEquipmentSettingCommandResult>> {
    return apiEquipmentSettingDeleteEquipmentSettingDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing equipment setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEquipmentSettingDeleteEquipmentSettingDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEquipmentSettingDeleteEquipmentSettingDelete(params?: ApiEquipmentSettingDeleteEquipmentSettingDelete$Params, context?: HttpContext): Observable<DeleteEquipmentSettingCommandResult> {
    return this.apiEquipmentSettingDeleteEquipmentSettingDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteEquipmentSettingCommandResult>): DeleteEquipmentSettingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiManpowerSettingGetManpowerSettingsPost()` */
  static readonly ApiManpowerSettingGetManpowerSettingsPostPath = '/api/ManpowerSetting/GetManpowerSettings';

  /**
   * Gets a list of manpower settings based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingGetManpowerSettingsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingGetManpowerSettingsPost$Plain$Response(params?: ApiManpowerSettingGetManpowerSettingsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManpowerSettingQueryResult>> {
    return apiManpowerSettingGetManpowerSettingsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of manpower settings based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingGetManpowerSettingsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingGetManpowerSettingsPost$Plain(params?: ApiManpowerSettingGetManpowerSettingsPost$Plain$Params, context?: HttpContext): Observable<GetManpowerSettingQueryResult> {
    return this.apiManpowerSettingGetManpowerSettingsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetManpowerSettingQueryResult>): GetManpowerSettingQueryResult => r.body)
    );
  }

  /**
   * Gets a list of manpower settings based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingGetManpowerSettingsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingGetManpowerSettingsPost$Response(params?: ApiManpowerSettingGetManpowerSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManpowerSettingQueryResult>> {
    return apiManpowerSettingGetManpowerSettingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of manpower settings based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingGetManpowerSettingsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingGetManpowerSettingsPost(params?: ApiManpowerSettingGetManpowerSettingsPost$Params, context?: HttpContext): Observable<GetManpowerSettingQueryResult> {
    return this.apiManpowerSettingGetManpowerSettingsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetManpowerSettingQueryResult>): GetManpowerSettingQueryResult => r.body)
    );
  }

  /** Path part for operation `apiManpowerSettingCreateManpowerSettingPost()` */
  static readonly ApiManpowerSettingCreateManpowerSettingPostPath = '/api/ManpowerSetting/CreateManpowerSetting';

  /**
   * Creates a new manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingCreateManpowerSettingPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingCreateManpowerSettingPost$Plain$Response(params?: ApiManpowerSettingCreateManpowerSettingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateManpowerSettingCommandResult>> {
    return apiManpowerSettingCreateManpowerSettingPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingCreateManpowerSettingPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingCreateManpowerSettingPost$Plain(params?: ApiManpowerSettingCreateManpowerSettingPost$Plain$Params, context?: HttpContext): Observable<CreateManpowerSettingCommandResult> {
    return this.apiManpowerSettingCreateManpowerSettingPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateManpowerSettingCommandResult>): CreateManpowerSettingCommandResult => r.body)
    );
  }

  /**
   * Creates a new manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingCreateManpowerSettingPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingCreateManpowerSettingPost$Response(params?: ApiManpowerSettingCreateManpowerSettingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateManpowerSettingCommandResult>> {
    return apiManpowerSettingCreateManpowerSettingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingCreateManpowerSettingPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingCreateManpowerSettingPost(params?: ApiManpowerSettingCreateManpowerSettingPost$Params, context?: HttpContext): Observable<CreateManpowerSettingCommandResult> {
    return this.apiManpowerSettingCreateManpowerSettingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateManpowerSettingCommandResult>): CreateManpowerSettingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiManpowerSettingUpdateManpowerSettingPut()` */
  static readonly ApiManpowerSettingUpdateManpowerSettingPutPath = '/api/ManpowerSetting/UpdateManpowerSetting';

  /**
   * Updates an existing manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingUpdateManpowerSettingPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingUpdateManpowerSettingPut$Plain$Response(params?: ApiManpowerSettingUpdateManpowerSettingPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateManpowerSettingCommandResult>> {
    return apiManpowerSettingUpdateManpowerSettingPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingUpdateManpowerSettingPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingUpdateManpowerSettingPut$Plain(params?: ApiManpowerSettingUpdateManpowerSettingPut$Plain$Params, context?: HttpContext): Observable<UpdateManpowerSettingCommandResult> {
    return this.apiManpowerSettingUpdateManpowerSettingPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateManpowerSettingCommandResult>): UpdateManpowerSettingCommandResult => r.body)
    );
  }

  /**
   * Updates an existing manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingUpdateManpowerSettingPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingUpdateManpowerSettingPut$Response(params?: ApiManpowerSettingUpdateManpowerSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateManpowerSettingCommandResult>> {
    return apiManpowerSettingUpdateManpowerSettingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingUpdateManpowerSettingPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingUpdateManpowerSettingPut(params?: ApiManpowerSettingUpdateManpowerSettingPut$Params, context?: HttpContext): Observable<UpdateManpowerSettingCommandResult> {
    return this.apiManpowerSettingUpdateManpowerSettingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateManpowerSettingCommandResult>): UpdateManpowerSettingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiManpowerSettingDeleteManpowerSettingDelete()` */
  static readonly ApiManpowerSettingDeleteManpowerSettingDeletePath = '/api/ManpowerSetting/DeleteManpowerSetting';

  /**
   * Deletes an existing manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingDeleteManpowerSettingDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingDeleteManpowerSettingDelete$Plain$Response(params?: ApiManpowerSettingDeleteManpowerSettingDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteManpowerSettingCommandResult>> {
    return apiManpowerSettingDeleteManpowerSettingDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingDeleteManpowerSettingDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingDeleteManpowerSettingDelete$Plain(params?: ApiManpowerSettingDeleteManpowerSettingDelete$Plain$Params, context?: HttpContext): Observable<DeleteManpowerSettingCommandResult> {
    return this.apiManpowerSettingDeleteManpowerSettingDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteManpowerSettingCommandResult>): DeleteManpowerSettingCommandResult => r.body)
    );
  }

  /**
   * Deletes an existing manpower setting record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManpowerSettingDeleteManpowerSettingDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingDeleteManpowerSettingDelete$Response(params?: ApiManpowerSettingDeleteManpowerSettingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteManpowerSettingCommandResult>> {
    return apiManpowerSettingDeleteManpowerSettingDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing manpower setting record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiManpowerSettingDeleteManpowerSettingDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManpowerSettingDeleteManpowerSettingDelete(params?: ApiManpowerSettingDeleteManpowerSettingDelete$Params, context?: HttpContext): Observable<DeleteManpowerSettingCommandResult> {
    return this.apiManpowerSettingDeleteManpowerSettingDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteManpowerSettingCommandResult>): DeleteManpowerSettingCommandResult => r.body)
    );
  }

}
